const initialRowsPerPage = 10;
const initialOrder = "-created_at";

export const initialQuery = {
    limit: initialRowsPerPage,
    offset: 0,
    order: initialOrder,
};
